if (document.querySelector('.quick-add__submit') && screen.width > 750) {
    const button = document.querySelector('.quick-add__submit:not([disabled])');
    const buttonSoldoutAll = document.querySelectorAll(' .quick-add__submit[disabled]');
    if(button && buttonSoldoutAll){
      buttonSoldoutAll.forEach(buttonSoldOut => {
          buttonSoldOut.style.height = button.offsetHeight + "px"
      })
  }
}

const referralBanner = document.querySelector('.referral-modal-wrapper');
if(referralBanner) {
// referral link logic
document.addEventListener('DOMContentLoaded', () => {
    function getCookieValue(name) {
        const value = document.cookie
          .split('; ')
          .find(row => row.startsWith(name + '='))
          ?.split('=')[1];
        
        return value ? decodeURIComponent(value) : null;
      }

      const discountCode = getCookieValue('discount_code');
      const discountCodes_ = referralBanner.dataset.discountCodes.split(',');
      let discountCodes = discountCodes_.map(str => str.replace(/\s+/g, ""));
      const discountAmounts = referralBanner.dataset.discountAmounts.split(',');
      if (discountCodes.includes(discountCode)) {
        
        function changePrices(discountAmount) {

          const cssSelectorOne = referralBanner.dataset.collection ? `.price--on-sale.${referralBanner.dataset.collection}` : '.price--on-sale'
          document.querySelectorAll(`${cssSelectorOne} .price__sale`).forEach(price => {
            if(!price.classList.contains('adjusted-prices')) {
            const strikethroughPrice = Number(price.querySelector('.strikethrough-price').dataset.price);
            const currentPrice = Number(price.querySelector('.price-item--regular').dataset.price);
            const newPrice  = currentPrice * ((100 - Number(discountAmount))/100);
            price.querySelector('.discount-bubble').textContent = `${Math.round(((newPrice - strikethroughPrice) / strikethroughPrice) * 100)}%`;
            price.querySelector('.price-item--regular').textContent = `€ ${(newPrice/100).toFixed(2).replace('.', ',')}`;
            price.classList.add('adjusted-prices');
            }
          });
  
          const cssSelectorTwo = referralBanner.dataset.collection ? `.price.${referralBanner.dataset.collection}` : '.price'
          document.querySelectorAll(`${cssSelectorTwo}:not(.price--on-sale) .price__regular`).forEach(price => {
            if(!price.classList.contains('adjusted-prices')) {
            let oldPrice = Number(price.querySelector('.price-item--regular').dataset.price)
            price.querySelector('.discount-bubble').textContent = '-' + discountAmount + '%';
            price.querySelector('.price-item--regular').textContent = '€' + (oldPrice * ((100 - discountAmount )/100) / 100).toFixed(2).replace('.', ',') ;
            price.querySelector('.strikethrough-price').textContent = '€' + (oldPrice / 100).toFixed(2).replace('.', ',');
            price.classList.add('adjusted-prices');
            }
          });

          const cssSelectorThree = referralBanner.dataset.collection ? `.rc_ingredients_product--price.${referralBanner.dataset.collection}` : '.rc_ingredients_product--price'
          document.querySelectorAll(`${cssSelectorThree}`).forEach(price => {
            if(!price.classList.contains('adjusted-prices')) {
            let oldPrice = Number(price.dataset.price)
            price.textContent = '€' + (oldPrice * ((100 - discountAmount )/100) / 100).toFixed(2).replace('.', ',') ;
            price.classList.add('adjusted-prices');
            }
          });
      
          }

        const index = discountCodes.indexOf(discountCode) || 0;
        const discountAmount = Number(discountAmounts[index]) || Number(discountAmounts[0]) ;
        changePrices(discountAmount);
        if(localStorage.getItem('referral-modal-seen') === 'false' || !localStorage.getItem('referral-modal-seen')) {
          let seconds = Number(referralBanner.getAttribute('data-seconds')) || 4;
          seconds *= 1000;
          referralBanner.innerHTML = referralBanner.innerHTML
              .replace("CODE", discountCode)
              .replace("AMOUNT", discountAmount);
          referralBanner.style.display = 'flex';
          setTimeout(() => {
            referralBanner.style.display = 'none';
          },seconds)
          localStorage.setItem('referral-modal-seen', "true");
        }
          // Select the target element to observe
          const cartDrawer = document.querySelector('cart-drawer');
          const rebuyPDP = document.querySelector('.complementary-slider');
          const featuredCollection = document.querySelector('.featured-collection');

          // Check if the target element exists
          if (cartDrawer || rebuyPDP || featuredCollection) {
            // Create a callback function to run when mutations are observed
            const callback = (mutationsList, observer) => {
              for (const mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                  changePrices(discountAmount);
                  break;  
                }
              }
            };
            
            const observer = new MutationObserver(callback);
            const config = {
              childList: true,      // Observe changes to the child elements
              attributes: true,     // Observe changes to attributes
              subtree: true         // Observe changes within all descendants
            };

            // Start observing the target node
            if(cartDrawer) observer.observe(cartDrawer, config);
            if(rebuyPDP) observer.observe(rebuyPDP, config);
            if(featuredCollection) observer.observe(featuredCollection, config);
          } 
      } else {
        localStorage.setItem('referral-modal-seen', "false");
      }
  })
}

// open cart when you come from the cart page
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.search.includes('cart=open')) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    } 
  }
});

// change logo class on scroll
function updateLogoClass() {
  const logoContainer = document.querySelector(".logo-container");
  
  if (window.scrollY === 0) {
      logoContainer.classList.add("top");
  } else {
      logoContainer.classList.remove("top");
  }
}

document.addEventListener("DOMContentLoaded", updateLogoClass);
window.addEventListener("scroll", updateLogoClass);